import { createFileRoute } from '@tanstack/react-router';

const HealthComponent = () => {
  const data = Route.useLoaderData();

  return (
    <div style={{ fontFamily: 'monospace', padding: '20px' }}>
      <h1>Health Check</h1>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
};

export const Route = createFileRoute('/health')({
  loader: async () => {
    return {
      status: 'ok',
      timestamp: new Date().toISOString(),
      service: 'trypillian-landing',
    };
  },
  component: HealthComponent,
});
